module.exports = __webpack_public_path__ + "img/bcc303.04cd3294.jpeg";